import { render, staticRenderFns } from "./DemandCard.vue?vue&type=template&id=97c5f2b0"
import script from "./DemandCard.vue?vue&type=script&lang=js"
export * from "./DemandCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports